import { getAssetUrl } from "../../../api/api";
import Image from "../../image/image";
import "./cases-hero-block.sass";

type Props = {
  title: string;
  description?: string;
  img?: string;
};

const CasesHeroBlock = ({ title, description, img }: Props) => {
  return (
    <div className="cases-hero-block">
      <div className="cases-hero-block__left">
        <div className="cases-hero-block__title">{title}</div>

        <div className="cases-hero-block__description">{description}</div>
      </div>

      <Image
        src={getAssetUrl(img ?? "")}
        alt={title}
        className="cases-hero-block__img"
      />
    </div>
  );
};

export default CasesHeroBlock;
